<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";
import Swal from "sweetalert2";
import DataTable from "@/components/DataTable.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Expenses Payments Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    DataTable,
  },
  data() {
    return {
      data: {
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        supplier: "",
        mode: "",
        title: "Expenses Payments Report",
        page: 1,
        per_page: 50,
      },
      editdata: {
        id: "",
        amount: "",
        filterdata: {},
      },
      deletedata: {
        id: "",
        amount: "",
        filterdata: {},
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Expenses Payments Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Expenses Payments Report",
          active: true,
        },
      ],

      serverPerPage: 50,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      IsExpensePaymentsDataServerPaginated: true,
      filter: null,
      todoFilter: null,
      filterOn: [],
      filteredData: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "dateAdded",
          sortable: true,
          label: "DATE TIME",
        },
        {
          key: "supplier",
          sortable: true,
          label: "SUPPLIER",
        },
        {
          key: "amount",
          sortable: true,
          label: "AMOUNT",
        },
        {
          key: "receipt",
          sortable: true,
          label: "RECEIPT NO",
        },
        {
          key: "mode",
          sortable: true,
          label: "PAYMENT MODE",
        },
        {
          key: "user",
          sortable: true,
          label: "RECORDED BY",
        },
        {
          key: "actions",
          sortable: true,
          label: "ACTION",
        },
      ],
      json_fields: {
        DATE_TIME: "dateAdded",
        SUPPLIER: "supplier",
        AMOUNT: "amount",
        RECEIPT: "receipt",
        PAYMENT_MODE: "mode",
        RECORDED_BY: "user",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      amountError: "",
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("expenses", [
      "ExpensePaymentsData",
      "ExpensePaymentsDataPagination",
      "ExpensePaymentsDataSummary",
      "filterStatus",
      "ExpenseSaveStatus",
      "ExpensePaymentsDataPaginated",
    ]),
    ...mapGetters("stock", ["Suppliers"]),
    ...mapGetters("auth", [
      "MyUserPerm",
      "business",
      "branch",
      "Branches",
      "branchid",
    ]),

    expensePaymentColumns() {
      return this.fields;
    },

    rows() {
      return this.IsExpensePaymentsDataServerPaginated
        ? this.ExpensePaymentsDataPagination?.total
        : this.ExpensePaymentsData
        ? this.ExpensePaymentsData.length
        : 0;
    },

    
    perPage: {
      get() {
        if (this.IsExpensePaymentsDataServerPaginated) {
          return (
            (this.ExpensePaymentsDataPagination && this.ExpensePaymentsDataPagination.per_page) ||
            this.data.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsExpensePaymentsDataServerPaginated) {
          this.data.per_page = value;
          this.data.page = 1;
          this.FetchExpensesPayments(this.data);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.ExpensePaymentsDataPaginated && this.ExpensePaymentsDataPagination
          ? this.ExpensePaymentsDataPagination.current_page
          : 1;
      },
      set(value) {
        if (this.ExpensePaymentsDataPaginated) {
          this.data.page = value;
          this.handlePageChange(value);
        }
      },
    },

    totals() {
      return (
        this.ExpensePaymentsDataSummary || {
          totalAmount: 0,
        }
      );
    },
  },

  methods: {
    ...mapActions({
      FetchExpensesPayments: "expenses/fetchExpensePaymentsData",
      FetchSuppliers: "stock/fetchSuppliers",
      EditPayment: "expenses/EditPayment",
      DeletePayment: "expenses/DeletePayment",
    }),
   
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m === "" || m === undefined || m === null) {
        return m;
      }
      const str = m.toString();
      const integerPart = str.split(".")[0];
      return integerPart
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    removeCommas(value) {
      return typeof value === "string"
        ? parseFloat(value.replaceAll(",", ""))
        : parseFloat(value || 0);
    },

    filterReport() {
      let payload = { ...this.data };
      payload.page = 1;
      payload.per_page = this.serverPerPage;

      this.FetchExpensesPayments(payload);
    },

    handlePageChange(newPage) {
      if (this.IsExpensePaymentsDataServerPaginated) {
        this.data.page = newPage;
        this.FetchExpensesPayments(this.data);
      }
    },

    editAmt(modalId) {
      this.modal_id = modalId;
      if (this.editdata.amount == "") {
        this.amountError = "Amount field is required";
        return;
      } else {
        this.amountError = "";
      }
      const payload = {
        id: this.editdata.id,
        amount: this.removeCommas(this.editdata.amount),
        filterdata: this.data,
      };
      this.EditPayment(payload);
    },

    deletePayment(modalId) {
      this.modal_id = modalId;
      this.deletedata.filterdata = this.data;
      this.DeletePayment(this.deletedata);
    },
    addCommas() {
      this.editdata.amount = this.thousandSeperator(this.editdata.amount);
    },
    resetError() {
      this.amountError = "";
    },
    closeModal(modalId) {
      this.resetError();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    showEditModal(data) {
      this.editdata.amount = this.thousandSeperator(data.amount);
      this.editdata.id = data.id;
    },
    showDeleteModal(data) {
      this.deletedata.id = data.id;
      this.deletedata.amount = this.thousandSeperator(data.amount);
    },
    resetDelete() {
      this.deletedata.id = "";
      this.deletedata.amount = "";
    },

    resetEdit() {
      this.editdata.id = "";
      this.editdata.amount = "";
      this.amountError = "";
    },
  },

  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },

  created() {
    this.filterReport();
    this.FetchSuppliers();
    this.FetchExpensesPayments(this.data);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3
                  class="card-title mb-2 text-center"
                  v-html="data.title"
                ></h3>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mt-4">
                <download-excel
                  class="btn btn-info"
                  :data="ExpensePaymentsData"
                  :fields="json_fields"
                  :worksheet="'EXPENSE PAYMENTS REPORT FOR' + currentdate"
                  type="csv"
                  :name="'Expensepayments_report' + currentdate + '.xls'"
                >
                  Export Excel <i class="fa fa-download"></i>
                </download-excel>
              </div>
              <div class="col-md-2 form-group mb-2">
                <label>FROM</label>
                <input
                  type="date"
                  v-model="data.datefrom"
                  class="form-control"
                  v-limit-future-date
                />
              </div>
              <div class="col-md-2 form-group">
                <label>TO</label>
                <input v-model="data.dateto" type="date" class="form-control" v-limit-future-date />
              </div>
              <div class="col-md-3 form-group">
                <label>SUPPLIER</label>
                <model-list-select
                  :list="
                    Suppliers
                      ? [{ id: '', name: 'All Suppliers' }, ...Suppliers]
                      : []
                  "
                  v-model="data.supplier"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Supplier"
                  @input="filterReport()"
                >
                </model-list-select>
              </div>
              <div class="col-md-2 mt-4">
                <button
                  class="btn btn-primary"
                  type="button"
                  @click="filterReport()"
                >
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="filterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <DataTable
                :columns="expensePaymentColumns"
                :rows="ExpensePaymentsData"
                :total-rows="rows"
                :pagination="ExpensePaymentsDataPagination"
                :server-pagination="IsExpensePaymentsDataServerPaginated"
                :loading="filterStatus"
              >
                <template #cell(index)="{ index }">
                  {{ (currentPage - 1) * perPage + index + 1 }}
                </template>
                <template #cell(dateAdded)="{ value }">
                  {{ value }}
                </template>
                <template #cell(supplier)="{ value }">
                  {{ value }}
                </template>
                <template #cell(amount)="{ value }">
                  {{ thousandSeperator(value) }}
                </template>
                <template #cell(receipt)="{ value }">
                  {{ value }}
                </template>
                <template #cell(mode)="{ value }">
                  {{ value }}
                </template>
                <template #cell(user)="{ value }">
                  {{ value }}
                </template>
                <template #cell(actions)="{ row }">
                  <b-button-group>
                    <b-button
                      v-if="MyUserPerm && MyUserPerm.edit_expenses == 1"
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-payment-modal
                      @click="showEditModal(row)"
                    >
                      <i class="fa fa-edit"></i> Edit
                    </b-button>
                    <b-button
                      v-if="MyUserPerm && MyUserPerm.delete_expenses == 1"
                      size="sm"
                      variant="danger"
                      v-b-modal.delete-payment-modal
                      @click="showDeleteModal(row)"
                    >
                      <i class="fa fa-trash"></i> Delete
                    </b-button>
                  </b-button-group>
                </template>
              </DataTable>
              <div
                class="row"
                v-if="
                  ExpensePaymentsDataSummary &&
                  ExpensePaymentsDataSummary.totalAmount > 0
                "
              >
                <div class="col-md-5"></div>
                <div class="col-md-4">
                  <h5>
                    Total Amount:
                    <span class="text-danger">{{
                      thousandSeperator(totals.totalAmount)
                    }}</span>
                  </h5>
                </div>
              </div>

              <!-- modal mark as expired starts -->
              <b-modal id="edit-payment-modal" hide-footer @hidden="resetEdit">
                <template #modal-title>
                  <h4 class="text-warning">Edit Payment Amount</h4></template
                >
                <label>Amount Paid</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="editdata.amount"
                    placeholder="Enter actual amount"
                    @input="resetError(), addCommas()"
                  />
                </div>
                <div class="text-danger" v-if="amountError">
                  <em>{{ amountError }}</em>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                    @click="closeModal('edit-payment-modal')"
                  >
                    <i class="fa fa-times"></i> Close
                  </button>
                  <button
                    v-if="ExpenseSaveStatus"
                    type="button"
                    class="btn btn-warning"
                    disabled
                  >
                    <i class="fa fa-minus"></i> Confirm
                    <b-spinner
                      variant="light"
                      small
                      label="Submiting"
                    ></b-spinner>
                  </button>
                  <button
                    v-else
                    type="button"
                    class="btn btn-warning"
                    @click="editAmt('edit-payment-modal')"
                  >
                    <i class="fa fa-minus"></i> Confirm
                  </button>
                </div>
              </b-modal>
              <!-- modal ends -->
              <!--Payment delete modal starts -->
              <b-modal
                header-bg-variant="danger"
                header-text-variant="light"
                body-text-variant="danger"
                footer-bg-variant="danger"
                footer-text-variant="danger"
                id="delete-payment-modal"
                hide-footer
                @hidden="resetDelete"
              >
                <template #modal-title>
                  Delete Payment of amount
                  {{ thousandSeperator(deletedata.amount) }}</template
                >
                <div class="form-group mb-2">
                  <div class="input-group">
                    <h5>
                      Do you want to delete this Payment? Click Proceed Button
                      to delete.
                    </h5>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                    @click="closeModal('delete-payment-modal')"
                  >
                    <i class="fa fa-times"></i> Close
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger"
                    v-if="ExpenseSaveStatus"
                    disabled
                  >
                    <i class="fa fa-minus"></i> Proceed
                    <b-spinner
                      variant="light"
                      small
                      label="Submiting"
                    ></b-spinner>
                  </button>
                  <button
                    v-else
                    type="button"
                    class="btn btn-danger"
                    @click="deletePayment('delete-payment-modal')"
                  >
                    <i class="fa fa-minus"></i> Proceed
                  </button>
                </div>
              </b-modal>
              <!-- modal ends -->
            </div>
            <!--            <Loader  v-if="!ExpensePaymentsData && !filterStatus"/>-->
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
